"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconTarget from "@/app/(components)/generics/Icons/IconTarget/IconTarget";
import { useCanEditContent } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { useOfferActions } from "@/app/hooks/useOfferActions";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import styles from "./OfferRequired.module.css";

type Props = {
  params: PageParams;
};

export default function OfferRequired(props: Props) {
  const T = useT();
  const { params } = props;

  const canEdit = useCanEditContent();
  const offerActions = useOfferActions(params);

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <IconTarget size={28} />
      </div>

      <div className={styles.content}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {T(canEdit ? TKey.OFFER_REQUIRED_TITLE : TKey.OFFER_REQUIRED_TITLE_READER)}
          </h2>
          <span className={styles.badge}>{T(TKey.OFFER_REQUIRED_BADGE)}</span>
        </div>

        <p className={styles.description}>
          {T(canEdit ? TKey.OFFER_REQUIRED_TEXT : TKey.OFFER_REQUIRED_TEXT_READER)}
        </p>

        {canEdit && (
          <div className={styles.actions}>
            <Button
              min={true}
              isLink={false}
              type={ButtonType.PRIMARY}
              text={T(TKey.OFFER_REQUIRED_CTA) as string}
              onClick={offerActions.add}
            />
          </div>
        )}
      </div>
    </div>
  );
}
